<template>
  <div class="collection">
    <div class="header">
      <div class="header_section">
        <router-link to="/profile" class="header_icone header_element">
          <!--          <span class="icon icon-left-arrow icon-lg"></span>-->
          <font-awesome-icon color="#00d7fe" class="reverse" icon="angle-right"/>

        </router-link>
        <h1 class="header_element">Collection</h1>
      </div>
    </div>
    <!--    <div class="content_container" v-if="!getDeviceType(['desktop','tablet'])">-->
    <!--      <div class="content_section" v-for="(mask,index) in masksList">-->
    <!--        <div class="content-animal" :class="{'own': checkMask(mask.id)}">-->
    <!--          <img :src="mask.icon" alt="">{{ mask.name }}-->
    <!--        </div>-->
    <!--        <div class="content-texture" :class="{'own':checkTexture(mask.id, texture.id) }"-->
    <!--             v-for="(texture, index) in mask.textures ">-->
    <!--          <img :src="texture.icon" alt="">-->
    <!--          {{ texture.name }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="content_container desktop">
      <div class="content_section desktop" v-for="(mask,index) in masksList" :class="{'access': checkMask(mask.id)}">
        <div class="content-animal" :class="{'own': checkMask(mask.id)}">
          <img width="100%" :src="mask.icon" alt="" v-if="checkMask(mask.id)" @click="openTexture(mask)">
          <img width="100%" src="icon/icon-lock.png" :style="'background:no-repeat center/contain url('+mask.icon+')'"
               alt="" v-else>
        </div>
        <div class="textures-popup" :class="{'active':maskPopup}">
          <transition name="bounce" enter-active-class="animated bounceIn" leave-active-class="animated bounceOut">
            <div class="textures" v-if="maskPopup">
              <span class="close" @click="closePopup">Fermer</span>
              <div class="animal">
                <img width="100%" :src="maskPopup.icon" alt="">
              </div>
              <div class="container-textures">
                <div class="content-texture" :class="{'own':checkTexture(maskPopup.id, texture.id) }"
                     v-for="(texture, index) in maskPopup.textures " @click="openTatouage(maskPopup.id, texture.id)">
                  <img width="100%" :src="texture.icon" alt="" v-if="checkTexture(maskPopup.id, texture.id)">
                  <img width="100%" src="icon/icon-lock.png"
                       :style="'background:no-repeat center/contain url('+texture.icon+')'" alt="" v-else>
                </div>
              </div>
            </div>
          </transition>

        </div>
      </div>
    </div>

    <transition name="bounce" enter-active-class="animated bounceIn" leave-active-class="animated bounceOut">
      <div class="tatoo-container" v-if="tatouage">
        <img :src="tatouage" width="100%" alt="">
        <div class="close" @click="closeTatouage">Fermer</div>
      </div>
    </transition>


  </div>
</template>
<script>
import {store} from '../store/store';
import {mapState, mapActions} from "vuex";
import PopUp from "../components/Modals/Modal";

export default {
  name: 'Collection',
  data() {
    return {
      masksList: null,
      tatouage: null,
      maskPopup: null
    }
  },
  components: {
    PopUp
  },
  methods: {
    ...mapActions([
      'getMasks'
    ]),
    checkMask(id) {
      return this.masks.find(res => res.id_mask === id);
    },
    checkTexture(id_mask, id_texture) {
      let mask = this.masks.find(res => res.id_mask === id_mask)
      return mask.textures.find(res => res.id === id_texture);

    },
    getDeviceType(arrayValue) {
      let device = getDevice()
      return arrayValue.includes(device)
    },
    openTexture(mask) {
      // document.querySelector('.textures-popup').classList.add('active')
      this.maskPopup = mask
    },
    closePopup() {
      this.maskPopup = null
      // document.querySelector('.textures-popup').classList.remove('active')

    },
    openTatouage(id_mask, id_texture) {
      let mask = this.masks.find(res => res.id_mask === id_mask)
      if (mask.textures.find(res => res.id === id_texture).tatoo) {

        this.tatouage = mask.textures.find(res => res.id === id_texture).tatoo;
      }

    },
    closeTatouage() {
      this.tatouage = null
    }

  },
  computed: {
    ...mapState([
      "masks",
      "logged",
      "user"
    ])
  },
  mounted() {
    !localStorage.getItem('user') && this.$router.push({name: "login", params: {type: 'connexion'}});

    toggleLoader()
    this.getMasks().then(res => {
      this.masksList = res
      toggleLoader()

    })

  }
}
</script>
<style scoped>

.header {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}

.collection {
  z-index: 1;
  background: #fff;
  margin-bottom: 40px;
}

.header_icone {
  font-size: 30px;
  /*line-height: 80px;*/
}

.header_section {
  display: flex;
  align-items: center;
}

.header_section:first-child {
  justify-content: center;
  width: 100%;
}

.header_section:first-child .header_element:first-child {
  position: absolute;
  left: 10px;
}

.header_element {
  margin: 0 0 0 10px;
  color: #00d7fe;
  text-decoration: none;
}

h1.header_element {
  font-size: 3em;
  /*border-bottom:4px solid #00d7fe;*/
  padding: 0;
  position: relative;
}


.content_container {
  padding: 0 20px;
}


.content_section {
  margin: 20px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #297F9E;
}


.content_section:not('desktop'):last-child {
  border: none;
}

.content_section > * {
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content-animal {
  width: 70px;
  display: flex;
  justify-content: center;
}

.content_section img {
  border-radius: 50%;
  border: 1px solid #000;
}

.content_section .content-animal.own img, .content_section .content-texture.own img {
  border: 2px solid #00d6ff;
  border-radius: 5px;
}

.content_section .content-animal:not(.own) img, .content_section .content-texture:not(.own) img {
  background: dimgrey;
  filter: grayscale(100);
}

.content_container.desktop {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  /*position: relative;*/
}


.content_section.desktop {
  width: 22%;
  height: 200px;
  display: flex;
  justify-content: center;
  border: 2px solid #00d6ff;
  border-radius: 5px;
  text-align: center;
}

.content_section.desktop > * {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
}


.content_section.desktop img {
  border-radius: initial !important;
  border: none;
}

.content_section.desktop .content-animal {
  width: 60%;
  transition: .3s;

}

.content_section .content-animal.own img, .content_section .content-texture.own img {
  border: none;
}

.content_section.desktop .content-animal img, .content_section.desktop .content-texture img, .content_section.desktop .content-animal {
  background: none;
  filter: none;
  position: relative;
  transition: .3s;
}

.content_section.desktop.access:hover {
  cursor: pointer;
}

.content_section.desktop.access:hover .content-animal {
  width: 70%;
}

.textures:hover, .textures-popup:hover {
  cursor: initial;
}

.content_section .textures-popup {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  z-index: 5;
  background: var(--main-dark-color);
  display: none !important;
}

.content_section.desktop .textures {
  width: 80%;
  margin: auto;
  background: #fff;
  border-radius: 10px;
  /*border:2px solid #00d6ff;*/
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding: 10px;
  /*box-shadow: 1px 1px 8px 2px #737373;*/
}

.content_section.desktop .textures .animal {
  width: 20%;
}

.content_section.desktop .textures .container-textures {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
}

.content_section.desktop .textures .content-texture {
  display: flex;
  width: 15%;
  margin: 10px;
  flex-direction: column;
}

.content_section.desktop .textures-popup.active {
  display: flex !important;
}

.tatoo-container {
  position: absolute;
  height: 100vh;
  /*width: 100%;*/
  width: 70%;
  display: flex;
  justify-content: center;
  top: 0;
  left: calc(50% - 35%);
  z-index: 100;
}

.tatoo-container img {
  border-radius: 0;
  margin: auto;
}

.tatoo-container .close {
  bottom: 20px;
  margin: auto;
  background: var(--main-red-color);
  padding: 20px 40px;
}

.close, .own {
  transition: .3s;
}

.close:hover, .own:hover {
  cursor: pointer;
  filter: brightness(80%);

}

.content_name {
  text-align: center;
  color: #00d6ff;
  font-size: 35px;
  margin: 0;
  font-family: 'Bebas Neue', cursive;
  letter-spacing: 2px;
}

.content_success {
  text-align: center;
  color: #00a6d9;
  font-size: 20px;
  margin: 0;
  font-family: Calibri;
}

.content_icon {
  color: gold;
  font-size: 15px;
}

.content_element {
  color: white;
  border-radius: 20px;
  background-color: #00d6ff;
  height: 70px;
  display: flex;
  width: 90%;
  margin: 10px auto;
  justify-content: space-between;
}

span {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content_img {
  width: 150px;
  border-radius: 100%;
  height: auto;
  margin: auto;
}

.content_element_link {
  margin: auto 0;
  font-size: 20px;
}

.content_element_icon_arrow {
  font-size: 40px;
  color: #fff;
  padding-right: 10px;
}

.content_element_icon_description {
  font-size: 50px;
  padding-left: 10px;
}

a {
  text-decoration: none;
}

a.addinsta {
  color: #00a6d9;
}

.close {
  bottom: -15px;
  position: absolute;
  padding: 5px 20px;
  background: var(--main-color);
  text-transform: uppercase;
  border-radius: 5px;
  color: #fff;
}

.reverse {
  transform: rotateY(180deg);
}


/*     DESKTOP EXCEPTION       */
@media screen and (min-width: 750px) {

}


/*     MOBILE EXCEPTION       */
@media screen and (max-width: 750px) {

  .collection {
    width: 100vw;
  }

  .content_section {
    overflow: auto;
    border-right: 5px;
  }

  .tatoo-container {
    width: 100%;
    left: 0;
  }

}


</style>
